import * as types from "redux/types/configSyncType";
import { PROYECT, api_get } from "services/api";

import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";

export function getCompanies() {
  return {
    type: types.LOAD_CONFING_SYNC_COMPANIES,
  };
}

export function loadStationConfig(id_station, type, id_brand) {
  return async (dispatch) => {
    dispatch(startRequestComp("loadStationConfig"));
    try {
      let url = `${process.env.REACT_APP_URL}${PROYECT}/configuration?id_station=${id_station}`
      if (type) url += `&type=${type}`
      if (id_brand) url += `&id_brand=${id_brand}`

      await api_get(url).then(resp => {
        dispatch({
          type: types.LOAD_STATIONS_CONFIG,
          payload: resp
        })
        dispatch(stopRequestComp("component"))
      })
    } catch (error) {
      dispatch(stopRequestComp("component"))
      dispatch(setSnackbar('Error al buscar configuración de estación.'))
    }
  };
}
